import { render, staticRenderFns } from "./ScanCanvas.vue?vue&type=template&id=6f2d9512&scoped=true&"
import script from "./ScanCanvas.vue?vue&type=script&lang=js&"
export * from "./ScanCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ScanCanvas.vue?vue&type=style&index=0&id=6f2d9512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d9512",
  null
  
)

export default component.exports